import { faEnvelope, faMobileAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import {
    PASSWORD_RESET_CHOOSE_EMAIL,
    PASSWORD_RESET_CHOOSE_SMS,
    PASSWORD_RESET_DID_YOU_FORGET_PASSWORD,
} from 'mk/autogenerated/translations/PasswordResetChoose.2204b8532ccc1cdbf293170ff75425be'
import { Props, RouteProps } from 'mk2/apps/users/containers/PasswordResetChoose/PasswordResetChoosePage';
import { usersPasswordResetEmailUrl, usersPasswordResetPhoneUrl } from 'mk2/apps/users/urls';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Panel } from 'mk2/components/Panel';
import React from 'react';

const faEnvelopeLg: FontAwesomeIconProps = { icon: faEnvelope, size: '2x', fixedWidth: true };
const faMobileAltLg: FontAwesomeIconProps = { icon: faMobileAlt, size: '2x', fixedWidth: true };

export class PasswordResetChoose extends React.Component<Omit<Props, keyof RouteProps>> {

    public render() {
        return (
            <>
                <h1>{PASSWORD_RESET_DID_YOU_FORGET_PASSWORD}</h1>

                <Panel>
                    <div>
                        <Btn
                            link={usersPasswordResetEmailUrl}
                            type={BtnType.Link}
                            icon={faEnvelopeLg}
                            label={PASSWORD_RESET_CHOOSE_EMAIL}
                        />
                    </div>
                    <div>
                        <Btn
                            link={usersPasswordResetPhoneUrl}
                            type={BtnType.Link}
                            icon={faMobileAltLg}
                            label={PASSWORD_RESET_CHOOSE_SMS}
                        />
                    </div>
                </Panel>
            </>
        );
    }
}
